import { DynamicPackagesFormStepNames } from '../types';

const SINGLE_ROOM_V2_STEPS: string[] = [
  DynamicPackagesFormStepNames.GUESTS,
  DynamicPackagesFormStepNames.ROOM_EXTRAS,
  DynamicPackagesFormStepNames.SPA_EXTRAS,
];

const ANY_ROOM_V2_STEPS: string[] = [
  DynamicPackagesFormStepNames.EXPERIENCE,
  DynamicPackagesFormStepNames.TABLES,
];

export const usesV2Steps = (isEcom2Enabled: boolean, isMultiRoom: boolean) =>
  isEcom2Enabled && !isMultiRoom;

export const isInlineV2Step = (step: string, isEcom2Enabled: boolean, isMultiRoom: boolean) =>
  (isEcom2Enabled && ANY_ROOM_V2_STEPS.includes(step)) ||
  (usesV2Steps(isEcom2Enabled, isMultiRoom) && SINGLE_ROOM_V2_STEPS.includes(step));
